import * as Yup from "yup";
import {REQUIRED_FIELD} from "../constants";

export interface PaymentValues {
    payerFirstName: string,
    payerLastName: string,
    insuredFirstName: string,
    insuredLastName: string,
    payerEmail: string,
    paymentAmount: number,
    notes?: string,
    agreed: boolean,
    paymentMethodId?: string,
    trancheNumber?: string,
    fundingDate?: string,
    recurringPayment?: string,
    recurringPaymentDate?: string
    recurringPaymentAmount?: number
}

export interface BankValues {
    bankName?: string,
    bankAccountHolder?: string,
    routingNumber?: string,
    accountNumber?: string,
    confirmAccountNumber?: string,
    checkFrontPath?: string,
    bankAccountType?: string,
}

export interface EpayProps {
    handleClose: Function
}

export const paymentInitialValues: PaymentValues = {
    payerFirstName: "",
    payerLastName: "",
    insuredFirstName: "",
    insuredLastName: "",
    payerEmail: "",
    paymentAmount: 0,
    notes: "",
    agreed: false,
    paymentMethodId: "",
    trancheNumber: "",
    fundingDate: "",
    recurringPayment: "",
    recurringPaymentDate: "",
    recurringPaymentAmount: 0
};

export const bankInitialValues: BankValues = {
    bankName: "",
    bankAccountHolder: "",
    routingNumber: "",
    accountNumber: "",
    confirmAccountNumber: "",
    checkFrontPath: "",
    bankAccountType: "",
};

export const paymentSchema = {
    payerFirstName: Yup.string().required('Required'),
    payerLastName: Yup.string().required('Required'),
    payerEmail: Yup.string().email('Invalid email').required('Required'),
    paymentAmount: Yup.string().required("Required"),
    agreed: Yup.bool().required("Required")
        .oneOf([true], "Authorization must be accepted."),
};

export const paymentMethodIdSchema = {
    paymentMethodId: Yup.string().required(REQUIRED_FIELD),
};


export const bankSchema = {
    bankName: Yup.string().required("Required"),
    bankAccountHolder: Yup.string().required("Required"),
    routingNumber: Yup.string().required("Required"),
    bankAccountType: Yup.string().required("Required"),
    accountNumber: Yup.string().required("Required"),
    checkFrontPath: Yup.string().required("Required"),
    confirmAccountNumber: Yup.string().oneOf([Yup.ref('accountNumber')], 'Account number must match').required("Required"),
};

/**
 * Return Total Payment Amount with or without merchant fee
 * @param paymentArr - Payment Array to get amount
 * @param withoutFee - Without Merchant fee default false
 */
export const getPaymentAmount = (paymentArr: any, withoutFee: boolean = false): number => {
    let amount = paymentArr.amount[0].amount + (paymentArr.amount[1] && paymentArr.amount[1].amount ? paymentArr.amount[1].amount : 0);
    if (paymentArr.amount[2] && paymentArr.amount[2].amount && !withoutFee) {
        amount += paymentArr.amount[2].amount;
    }
    return amount;
}

export interface UpcomingPaymentListProps {
    count: number;
    rows: UpcomingPaymentProps[]
}

export interface UpcomingPaymentProps {
    amount: string;
    clientPolicy: {
        clientId: number;
        id: string;
        paymentFrequency: string;
        policyNumber: string;
        client: {
            id: number;
            user: { firstName: string; lastName: string };
        };
        tranche: { id: number; trancheNumber: number };
    },
    clientPolicyId: string;
    dueDate: string;
    frequency: number;
    id: number;
    paymentId: string;
    status: number;
    trancheId: number;
}

export interface PaymentLogProps {
    actionAt: string;
    actionBy: string;
    actionByUser?: { firstName: string; id: string; lastName: string; middleName: string; }
    actionType: string;
    clientPolicy?: { clientId: number; id: string; policyNumber: string; };
    clientPolicyUser: { firstName: string; id: string; lastName: string; middleName: string }
    details: string;
    message: string;
    PK: string;
    record: string;
    recordKey: string;
    refPk: string;
    refSk: string
    SK: string;
    updatedRecord: string;
}